import React from 'react';

interface Props {
  fillColor?: string;
}
function PainIcon({ fillColor = '#17385D' }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none">
      <g clipPath="url(#clip0_851_3346)">
        <path
          d="M1.21268 0.159551C0.887676 -0.0966993 0.415801 -0.0373243 0.159551 0.287676C-0.0966993 0.612676 -0.0373243 1.08455 0.287676 1.3408L18.7877 15.8408C19.1127 16.097 19.5846 16.0377 19.8408 15.7127C20.0971 15.3877 20.0377 14.9158 19.7127 14.6596L14.0689 10.2377L15.6158 8.92518C15.8596 8.71893 16.0002 8.41268 16.0002 8.09393C16.0002 7.4908 15.5127 7.0033 14.9096 7.0033H12.2471L13.9189 1.14393C14.0814 0.572051 13.6502 0.000175656 13.0533 0.000175656C12.8408 0.000175656 12.6314 0.0751757 12.4689 0.215801L7.12205 4.7908L1.21268 0.159551ZM8.32518 5.73455L11.9252 2.65643L10.5471 7.4783L8.32518 5.73768V5.73455ZM11.8533 8.50018H13.7971L12.8658 9.2908L11.8533 8.50018ZM11.7158 12.2314L10.5127 11.2846L8.06893 13.3596L9.0033 10.0939L7.73143 9.0908L6.08143 14.8564C5.91893 15.4314 6.34705 16.0002 6.94393 16.0002C7.15643 16.0002 7.36268 15.9252 7.52518 15.7877L11.7158 12.2314ZM4.79705 6.7783L4.36893 7.14393C4.13455 7.34393 4.00018 7.63768 4.00018 7.94393C4.00018 8.52518 4.47205 8.99705 5.0533 8.99705H7.6158L4.79705 6.77518V6.7783Z"
          fill={fillColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_851_3346">
          <rect width="20" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default PainIcon;
